import React from 'react';
import { Avatar, lighten, SxProps, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import {
    type DocumentColor,
    type DocumentIconType,
} from '../../../hooks/useDossierDocumentFilesApi';

export type DocumentIconProps = {
    icon: DocumentIconType | 'file-arrow-down' | 'cloud-arrow-down';
    color?: DocumentColor;
    transparentBackground?: boolean;
    sx?: SxProps;
};

const DocumentIcon: React.FunctionComponent<DocumentIconProps> = function (props) {
    const { icon, color = 'secondary', transparentBackground = false, sx } = props;
    const { palette } = useTheme();
    const baseColor = palette[color].main;

    const avatarSx = {
        display: 'flex',
        borderRadius: '8px',
        backgroundColor: transparentBackground ? 'transparent' : lighten(baseColor, 0.92),
        minHeight: '36px',
        minWidth: '36px',
        ...sx,
    };

    const avatarIconSx = {
        fontSize: '16px',
        lineHeight: '16px',
        fontWeight: '400',
        color: palette[color].main,
    };

    return (
        <Avatar
            data-testid="document-icon"
            sx={avatarSx}
        >
            <FaOptionIcon
                icon={['fasl', icon]}
                sx={avatarIconSx}
            />
        </Avatar>
    );
};

export default DocumentIcon;
